import { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { LineChart as Icon } from "lucide-react";
import { api } from "../lib/api";

const AR_M = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];

export const VariableCostTrend = ({ month }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.variableCostTrend(month).then((r) => setRows(r.months.map((m) => ({ ...m, name: AR_M[Number(m.month.slice(5, 7)) - 1] })))).catch(() => setRows([]));
  }, [month]);
  if (!rows) return null;
  const withData = rows.filter((r) => r.total > 0);
  const last = rows[rows.length - 1], prev = rows[rows.length - 2];
  const delta = prev?.total ? Math.round(((last.total - prev.total) / prev.total) * 100) : null;
  return (
    <div className="rounded-2xl border border-slate-200 p-3 space-y-2" data-testid="variable-cost-trend">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-1.5 text-sm font-semibold text-slate-700"><Icon className="h-4 w-4 text-teal-600" /> اتجاه المصروفات المتغيرة — آخر 6 أشهر</p>
        {delta !== null && <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${delta > 0 ? "bg-red-50 text-red-700" : "bg-emerald-50 text-emerald-700"}`} data-testid="variable-trend-delta">{delta > 0 ? "▲" : "▼"} {Math.abs(delta)}% عن الشهر السابق</span>}
      </div>
      {!withData.length ? <p className="py-6 text-center text-xs text-slate-400">لا توجد مصروفات محفوظة في آخر 6 أشهر</p> : (
        <div className="h-56" dir="ltr">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
              <XAxis dataKey="name" tick={{ fontSize: 11 }} reversed />
              <YAxis tick={{ fontSize: 10 }} width={50} orientation="right" />
              <Tooltip formatter={(v) => Number(v).toLocaleString("en")} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Bar dataKey="fuel" name="البنزين" stackId="a" fill="#f59e0b" />
              <Bar dataKey="maint" name="الصيانة" stackId="a" fill="#3b82f6" />
              <Bar dataKey="other" name="أخرى" stackId="a" fill="#94a3b8" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
